import React, { useState } from 'react'
import DetailsBox from '../../../../components/Cards/DetailsBox'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Chip,
  Grid,
  TextField,
} from '@mui/material'
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined'
import moment from 'moment'
import AnDateTimePicker from '../../../../components/DateTime/DateTimePicker'
import API from '../../../../services/API'
import ExternalWitnessRequests from './ExternalWitnessRequests'

const WitnessStatements = ({ incident, setIncident, loadIncident }) => {
  const [newName, setNewName] = useState('')
  const [newContact, setNewContact] = useState('')
  const [newInvolvement, setNewInvolvement] = useState('')
  const [newStatement, setNewStatement] = useState('')
  const [newTime, setNewTime] = useState(moment())

  const handleSubmit = (e) => {
    e.preventDefault()
    API.put('/incident/' + incident._id, {
      $push: {
        witnessStatements: {
          witnessName: newName,
          witnessContact: newContact,
          witnessInvolvement: newInvolvement,
          witnessStatement: newStatement,
          statementTime: moment(newTime).toDate(),
        },
      },
    }).then((res) => {
      if (res.status === 200) {
        setIncident((prev) => ({
          ...prev,
          witnessStatements: [
            ...(prev.witnessStatements ?? []),
            {
              witnessName: newName,
              witnessContact: newContact,
              witnessInvolvement: newInvolvement,
              witnessStatement: newStatement,
              statementTime: moment(newTime).toDate(),
              source: 'internal',
            },
          ],
        }))
        setNewName('')
        setNewContact('')
        setNewInvolvement('')
        setNewStatement('')
        setNewTime(moment())
      }
    })
  }
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={1}
      minHeight="100%"
      overflow="auto"
      justifyContent="stretch"
      padding={1}
    >
      <ExternalWitnessRequests
        incident={incident}
        setIncident={setIncident}
        onStatementsChanged={loadIncident}
      />
      <Accordion
        variant="outlined"
        sx={{ borderRadius: 2.5, '&:before': { display: 'none' } }}
      >
        <AccordionSummary
          sx={{
            bgcolor: 'action.hover',
            fontWeight: 600,
            borderRadius: 2.5,
          }}
        >
          Record a Statement Yourself
        </AccordionSummary>
        <AccordionDetails>
          <Grid
            container
            columnSpacing={1}
            rowSpacing={2}
            component="form"
            onSubmit={handleSubmit}
          >
            <Grid item xs={12} lg={6}>
              <TextField
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                label="Witness Name"
                fullWidth
                size="small"
                required
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <TextField
                value={newContact}
                onChange={(e) => setNewContact(e.target.value)}
                label="Witness Contact Details"
                fullWidth
                size="small"
                autoComplete="off"
                required
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <AnDateTimePicker
                date={newTime}
                onChange={(n) => setNewTime(n)}
                label="Statement Date/Time"
                fullWidth
                size="small"
                required
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <TextField
                value={newInvolvement}
                onChange={(e) => setNewInvolvement(e.target.value)}
                placeholder="Relationship to Incident"
                label="Witness Involvement"
                fullWidth
                size="small"
                autoComplete="off"
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                value={newStatement}
                onChange={(e) => setNewStatement(e.target.value)}
                label="Witness Statement"
                multiline
                minRows={4}
                fullWidth
                size="small"
                autoComplete="off"
                required
              />
            </Grid>
            <Grid item xs={12}>
              <Button variant="contained" type="submit" color="success">
                Submit
              </Button>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      {incident?.witnessStatements?.map((statement, index) => (
        <DetailsBox
          key={statement._id ?? index}
          title={`Statement of ${statement.witnessName}`}
          textButton={
            statement.source === 'external' ? (
              <Chip
                size="small"
                color="success"
                variant="outlined"
                icon={<VerifiedUserOutlinedIcon />}
                label="Submitted by witness via secure link"
                sx={{ borderRadius: 1, fontWeight: 700 }}
              />
            ) : null
          }
          caption={
            statement.source === 'external' && statement.submittedAt
              ? `Submitted ${moment(statement.submittedAt).format('Do MMM YYYY [at] HH:mm')} — declaration of truth and privacy notice accepted by the witness.`
              : undefined
          }
          rows={[
            { label: 'Name', value: statement.witnessName },
            { label: 'Contact', value: statement.witnessContact },
            { label: 'Involvement', value: statement.witnessInvolvement },
            {
              label: 'Statement Date',
              value: moment(statement.statementTime).format('DD.MM.YYYY HH:mm'),
            },
            {
              label: 'Statement',
              value: statement.witnessStatement,
              fullWidth: true,
            },
          ]}
        />
      ))}
    </Box>
  )
}

export default WitnessStatements
